import { useDataChange, useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let city = useDataValue({
    context: 'new_address',
    path: 'city',
    viewPath: props.viewPath,
  })
  let setCity = useDataChange({
    context: 'new_address',
    path: 'city',
    viewPath: props.viewPath,
  })

  return async function onChange(value, change) {
    if (value.term !== city) {
      setCity(value.term)
    }
  }
}
